import httpV2 from '@/utils/httpV2'
import get from 'lodash/get'

export async function getRecommendTop100List() {
  const res = await httpV2.get("/stb/v2/top/100v2");
  // console.log(res)
  return get(res, "data.data_list", []).filter((v, i) => i < 100);
}
